<bl-modal-content #content
  [title]="title"
  [headerClose]="false"
  [footerButtonType]="footerButtonType"
>

  <div body>
    <div class="message-container">
      <span class="glyphicon glyphicon-exclamation-sign"></span>
      <div class="message" [innerHtml]="data?.message | blNl2br"></div>
    </div>
  </div>

  <div footer>
    <button
      class="btn btn-default"
      type="button"
      (click)="content.cancel()"
    >閉じる</button>
    <button
      class="btn btn-default"
      type="button"
      (click)="content.any()"
      [tooltip]="anyButtonTooltip"
      placement="bottom"
    >設定動画を確認</button>
    <button #okBtn
      class="btn btn-success"
      type="button"
      (click)="content.done()"
    >設定</button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/yahoo-publickey-warn-modal/yahoo-publickey-warn-modal.component.html